<template>
  <div>
    <div v-if="!job_content">
      <el-row>
        <el-col :span="7"><p class="start_p">{{language == 'zh'?'岗位名称':'Name'}}</p></el-col>
        <el-col :span="4"><p class="center_p">{{language == 'zh'?'招聘部门':'Department'}}</p></el-col>
        <el-col :span="3"><p class="center_p">{{language == 'zh'?'招聘人数':'Headcount No.'}}</p></el-col>
        <el-col :span="3"><p class="center_p">{{language == 'zh'?'工作地点':'Add.'}}</p></el-col>
        <el-col :span="7"><p class="center_p">{{language == 'zh'?'岗位详情':'Description'}}</p></el-col>
      </el-row>
      <el-divider class="divider_div"></el-divider>
      <div
        :class="[i % 2 == 0 ? 'job_item_div2' : 'job_item_div']"
        v-for="(i,inx) in data"
        :key="inx"
        @click="getJobDetail(i)"
      >
        <el-row>
          <el-col :span="7">
            <div class="flex_div">
              <p class="start_p">{{language == 'zh'?i.name:i.nameEn}}</p>
              <el-divider direction="vertical"></el-divider>
            </div>
          </el-col>
          <el-col :span="4"
            ><div class="flex_div">
              <p class="center_p">{{language == 'zh'?i.department:i.departmentEnameEn}}</p>
              <el-divider direction="vertical"></el-divider></div
          ></el-col>
          <el-col :span="3"
            ><div class="flex_div">
              <p class="center_p">{{i.num}}</p>
              <el-divider direction="vertical"></el-divider></div
          ></el-col>
          <el-col :span="3"
            ><div class="flex_div">
              <p class="center_p">{{language == 'zh'?i.local:i.localEn}}</p>
              <el-divider direction="vertical"></el-divider></div
          ></el-col>
          <el-col :span="7"
            ><div class="flex_div">
              <p class="center_p">{{language == 'zh'?i.key:i.keyEn}}</p>
            </div></el-col
          >
        </el-row>
      </div>
    </div>
    <div v-else>
      <div class="editor-content-view" v-html="language == 'zh'?job_content:job_contentEn"></div>
      <p class="jobBtn" @click="showSubmitDialog">{{language == 'zh'?'在线申请':'Online Application'}}</p>
    </div>
    <SubmitJobDialog ref="SubmitJobDialog" :job="job" :language="language"></SubmitJobDialog>
  </div>
</template>
<script>
import SubmitJobDialog from "./SubmitJobDialog.vue";
export default {
  components: {
    SubmitJobDialog,
  },
  props: {
      language: {
        type: String,
        default: ''
      }
    },
  data() {
    return {
      job_content: "",
      job_contentEn:"",
      job:{},
      data:[]
    };
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.$http
        .get("/hdbs/api/contacts/job", {
        })
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.data = response.data.data.list
            }
          }.bind(this)
        )
    },
    getJobDetail(data) {
      this.job_content = data.description;
      this.job_contentEn = data.descriptionEn;
      this.job = data
    },
    showSubmitDialog() {
        this.$refs.SubmitJobDialog.init();
    },
  },
};
</script>

<style  lang="stylus" scoped>
.flex_div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 16rem;

  p {
    margin-bottom: 0;
  }
}

.start_p {
  margin-left: 5rem;
  display: inline-block;
  vertical-align: middle;
}

.center_p {
  width: 100%;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
}

.end_p {
  marigin-right: 1rem;
  display: inline-block;
  vertical-align: middle;
}

.el-divider--vertical {
  margin: 0;
  height: 80%;
  background-color: var(--garyD5);
}

.job_item_div {
  cursor: pointer;
  background-color: var(--garyE2);
  border-radius: 6px;
  margin-bottom: 2rem;
}

.job_item_div2 {
  cursor: pointer;
  background-color: var(--garyEF);
  border-radius: 6px;
  margin-bottom: 2rem;
}

.divider_div {
  margin-top: 0;
}

.jobBtn {
  text-align: center;
  width:16rem;
  height:5rem;
  cursor: pointer;
  margin: 0;
  color: #fff;
  background-color: var(--mainBlue);
  line-height: 5rem;
  border-radius: 6px;
  box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.12);
}
</style>


// WEBPACK FOOTER //
// src/components/CallUs/Job.vue